import React from 'react';
import styled, { withTheme } from "styled-components";
const IconWrapper = styled.div `
  padding: 0;
  margin: 0;
  display: block;
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  min-width: ${(props) => props.size}px !important;
  border-radius: 50%;
  display:flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: ${(props) => props.theme.button.background}
`;
const Icon = styled.div `
display: inline-block;
font-size: ${(props) => props.size - 15}px;
`;
const OperatorIcon = (props) => {
    return (React.createElement(IconWrapper, { size: props.size },
        React.createElement(Icon, { size: props.size }, props.name)));
};
export default withTheme(OperatorIcon);
